import { CensusSnapshot } from './census-snapshot.model';
import { MeasureRecord } from './measure-record.model';
import { PatientCensusRecord } from './patient-census-record.model';
import { PatientRatioRecord } from './patient-ratio-record.model';
import { StaffingPlan } from './staffing-plan.model';
import { VarianceReasonRecord } from './variance-reason-record.model';

export class InpatientDetails {
    constructor() {
        this.censusSnapshots = [];
        this.measures = [];
        this.patientRatios = [];
        this.staffingPlans = [];
        this.varianceReasons = [];
    }

    censusSnapshots: CensusSnapshot[];
    measures: MeasureRecord[];
    patientCensus: PatientCensusRecord;
    patientRatios: PatientRatioRecord[];
    staffingPlans: StaffingPlan[];
    varianceReasons: VarianceReasonRecord[];
}